const state = {
    hasImport: false,
    imported: null,
};

const mutations = {
    GET_INFO(state, data) {
        state.imported = data;
        state.hasImport = true;
    },
    CLEAR_IMPORTED_INFO(state) {
        state.imported = null;
        state.hasImport = false;
    }
};

const actions = {
    importData({ commit }, data) {
        commit('GET_INFO', data);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
